module.exports = __webpack_public_path__ + "static/media/payments.8545b468.png";